export const InvoiceFooter = () => {
  const contact = "HOT LINE: 09642222555 | info@jananiexpress.com";
  return (
    <div>
      {/* Signatures */}
      <div className="grid grid-cols-4 gap-8 px-6 pt-16 pb-8 text-center">
        <div>
          <div className="border-t border-gray-400 mb-1" />
         Receive By
        </div>
        <div>
          <div className="border-t border-gray-400 mb-1" />
         IT Officer
        </div>
        <div>
          <div className="border-t border-gray-400 mb-1" />
         General Manager
        </div>

          <div>
          <div className="border-t border-gray-400 mb-1" />
     Managing Director
        </div>


      </div>

      <div className="border-t border-gray-300 text-center text-sm py-2">
        {contact}
      </div>
    </div>
  );
};
